import React from 'react'
import { savePaginationData } from '../../../../../redux/features/globalDatagridSlice'
import GlobalDeleteDialog from '../../../../../components/mui/Dialogue/GlobalDeleteDialog'
import { deleteEvaluationTrack, getEvaluationTracker } from '../../../../../redux/features/CRDslice'
import { useSelector } from 'react-redux'

const DeleteEvaluationTrack = ({paginationDetails,admissionNo,id}) => {
//   const {selectedDate, pageNumber, pageLimit }=paginationDetails
     const {loading}=useSelector((store)=>store.crd)
     const { paginationData } = useSelector((state) => state.globalDataGrid)
   return (
     <GlobalDeleteDialog
     disabled={false}
     title={"Delete"}
     deleteNote={"Are you sure? you want to delete this Evaluation Track..?"}
     api={deleteEvaluationTrack(id)}
     upDateCall={ getEvaluationTracker(admissionNo)  }
    //  updatePaginationCall={savePaginationData({ ...paginationData, openAnchor: false })}
     loading={loading}
     />
   )
}

export default DeleteEvaluationTrack